module.exports = __webpack_public_path__ + "img/no_zone_selected.2561f3e5.svg";